import RateCardHeader from "./RateCardHeader";
export default RateCardHeader;
